import { Body1, Header1 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import i18n from '@flatsy/utils/translations'
import { Button } from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux'
import { applicationSlice } from 'src/redux/slices/Application'
import useStyles from './Style'

const ShowSlotAlreadyTaken: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const handleGoToApplication = () => {
    dispatch(applicationSlice.actions.setJustCompletedToFalse())
  }
  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.inner}>
          <img
            className={classes.illu}
            src={FlatsyTheme.image.qualification.alreadyTaken}
            alt="watch illustration"
          />
          <Header1 align="center" className={classes.title}>
            {i18n.t('you_have_got_competition')}
          </Header1>
          <Body1 className={classes.text} align="center">
            {i18n.t('unfortunately_someone_was_faster_than_you')}
          </Body1>
          <Body1 className={classes.text} align="center">
            {i18n.t(
              'thankfully_you_can_choose_a_new_time_for_your_tour_by_clicking_on_the_button_below'
            )}
          </Body1>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.button}
            onClick={handleGoToApplication}
          >
            {i18n.t('pick_a_new_time_slot')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ShowSlotAlreadyTaken
